import { render, staticRenderFns } from "./ConsolidationModule.vue?vue&type=template&id=0a7dd65a"
import script from "./ConsolidationModule.vue?vue&type=script&lang=js"
export * from "./ConsolidationModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports